import { OrganizationSelection } from "../user/organization-selection.model";

export class SearchFleetWebUserQuery {
  constructor(jsonObject: any = null) {
    this.pageSize = 20;
    this.page = 1;
    this.existingUsersOnly = true;

    if (jsonObject == null) {
      return;
    }

    this.pageSize = jsonObject.pageSize;
    this.page = jsonObject.page;

    this.frameAgreementId = jsonObject.frameAgreementId;
    this.tenantId = jsonObject.tenantId;
    this.firstName = jsonObject.firstName;
    this.lastName = jsonObject.lastName;
    this.socialSecurityNumber = jsonObject.socialSecurityNumber;
    this.email = jsonObject.email;
    this.existingUsersOnly = jsonObject.existingUsersOnly;
    this.organization = jsonObject.organization ? new OrganizationSelection(jsonObject.organization) : null;
    this.groups = jsonObject.groups ? jsonObject.groups : [];
  }

  pageSize: number;
  page: number;

  frameAgreementId: number;
  tenantId: string;
  firstName: string;
  lastName: string;
  socialSecurityNumber: string;
  email: string;
  existingUsersOnly: boolean;

  groups: string[]  = [];
  
  //Only used for filter persistance:
  organization: OrganizationSelection;

  toQueryString() {
    let queryString =
      "?pagesize=" + this.pageSize +
      "&page=" + this.page;

    if (this.frameAgreementId) {
      queryString += "&frameAgreementId=" + this.frameAgreementId;
    }

    if (this.tenantId) {
      queryString += "&tenantId=" + this.tenantId;
    }

    if (this.firstName) {
      queryString += "&firstName=" + this.firstName;
    }

    if (this.lastName) {
      queryString += "&lastName=" + this.lastName;
    }

    if (this.socialSecurityNumber) {
      queryString += "&socialSecurityNumber=" + this.socialSecurityNumber;
    }

    if (this.email) {
      queryString += "&email=" + this.email;
    }

    if (this.existingUsersOnly) {
      queryString += "&existingUsersOnly=" + this.existingUsersOnly;
    }

    this.groups.forEach(g => {
      queryString +="&groups=" + g;
    });

    return queryString;
  }
}